import { useEffect } from "react";
import { useLocation } from "react-router";
import ReactGA from "react-ga4";
import posthog, { isPostHogReady } from "../analytics/posthogClient";

const PathTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: pathname });

    if (isPostHogReady()) {
      posthog.capture("$pageview", { pathname });
    }
  }, [pathname]);

  return null;
};

export default PathTracker;
